// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--9-oneOf-1-1!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/src/index.js??ref--9-oneOf-1-2!../../assets/static/css/common/radius.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, ".left-img[data-v-50a6db70] {\n  width: 0.854167rem;\n  height: 0.677083rem;\n  line-height: 0.677083rem;\n  background-color: #f5f7fa;\n}\n.right-txt[data-v-50a6db70] {\n  width: calc(100% - 0.854167rem - 0.104167rem);\n}", ""]);
// Exports
module.exports = exports;
